import src from "IMAGE";
export default { src, width: 577, height: 309, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAMklEQVR42m2MQQ4AIAjDBpv+/8nKEg+oTXqAJgN+KIkp2UZUJG34uhg7MLM/z1T5RGABHucAgLIjfLQAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 4 }
